import { useMutation, useQueryClient } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useZoneManage() {
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ zoneSerialNumber, data }) => {
      return axiosPrivate({
        method: "PUT",
        url: `Zone/Manage/${zoneSerialNumber}`,
        data,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getZonesByPropertyId"]);
    },
  });
}

export default useZoneManage;
